// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"af7ecf3c","147":"9fe9b391","156":"097d0179","438":"387cc76a","706":"64c1a567","726":"daa99eae"}[chunkId] + ".chunk.js";
};